import React from "react";
import NavbarComponent from '../component/NavbarComponent'

const Library = () => {
  return (
    <React.Fragment>
      <NavbarComponent />
      <div className="relative z-0 min-h-screen">
        <img src="../assets/library.jpg" alt="pic" className="absolute top-0 opacity-80 h-full w-full"/>
      <div className="lg:grid lg:grid-cols-5 gap-10 lg:p-20 p-10 opacity-90">
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2 ">
            <div className="font-bold">
              <span>Books in Library</span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">4000</span>
            </div>
          </div>
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2">
            <div className="font-bold">
              <span>Total no of Publisher </span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">75</span>
            </div>
          </div>
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2">
            <div className="font-bold">
              <span>Total no of Registered Staff's </span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">16</span>
            </div>
          </div>
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2">
            <div className="font-bold">
              <span>Total no of Books </span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">756</span>
            </div>
          </div>
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2">
            <div className="font-bold">
              <span>Total no of Registered Student </span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">56</span>
            </div>
          </div>
        </div>
        <div className="opacity-90 pb-10">
        <div className=" font-semibold text-center">
          <span className="text-center text-4xl border-b-2">LIBRARY</span>
        </div>
        <div className="text-center pt-5">
          <span className="text-xl font-semibold ">
            Books are packed with knowledge, they give you life lessons, <br />
            they teach you about hardships, love, fear, and every little thing
            that is a part of life
          </span>
        </div>
        <div className=" font-semibold text-center mt-5">
          <p className="text-center text-xl">
            Our library, abound with thousands of books and articles and a rich
            resource centre.
            <br /> With our extensive collection of books authored by acclaimed
            writers empowers students with the imagination to explore the world
          </p>
        </div>
        </div>
        </div>

        <footer className="border-t-2">
     <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span
            className="text-black text-lg font-bold hover:text-blue-300 "
          
          >
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
     </footer>
    </React.Fragment>
  );
};

export default Library;
